<template>
    <div class="grid-manage">
        <left
            :gridList="gridList"
            :getGridAreaList="getGridAreaList"
            :selectFn="selectFn"
            :selectId="selectId"
            :getGridList="getGridList"
        ></left>
        <Middle
            :getGridList="getGridList"
            :gridList="gridList"
            :areaId="areaId"
            :getcurGridInfo="getcurGridInfo"
            :selectFn="selectFn"
        ></Middle>
        <Right
            v-if="selectId && curGridInfo.id"
            :gridList="gridList"
            :getcurGridInfo="getcurGridInfo"
            :curGridInfo="curGridInfo"
            :getGridList="getGridList"
            :searchParams="searchParams"
            @closeFormFn="closeFormFn"
        ></Right>
        <FilterSelect ref="FilterSelect" :getGridList="getGridList"></FilterSelect>
    </div>
</template>

<script>
import Left from './components/left.vue';
import Middle from './components/middle.vue';
import Right from './components/right.vue';
import FilterSelect from './components/filter-select.vue';
import GridPoints from './mapComponents/GridPoints.vue';
import createModule from './modules.js';
import api from './api.js';

export default {
    components: { Left, Middle, Right, FilterSelect },
    provide() {
        return {
            modules: this.modules,
        };
    },
    data() {
        const { AircraftModule, MixMapModule } = createModule();
        MixMapModule.input.map2dContent.push(this.renderMapLayers);

        return {
            modules: Object.freeze({
                AircraftModule,
                MixMapModule,
            }),
            gridAreaList: [],
            gridList: [],
            curGridInfo: {},
            areaId: '',
            searchParams: {
                areaId: '',
            },
            updateGridPoints: true,
            hasAirLine: true, // 已规划航线
            selectId: null, // 选中的网格id
        };
    },
    computed: {},
    watch: {},
    mounted() {
        this.getGridList();
        this.getGridAreaList();
    },
    methods: {
        closeFormFn() {
            this.selectId = null;
            this.$nextTick(() => {
                this.modules.MixMapModule.refreshSize();
            });
        },
        selectFn(item, type = true) {
            this.selectId = item.id;
            this.getcurGridInfo(item);
            if (type) {
                this.modules.MixMapModule.toCenter([item.points[0][0], item.points[0][1], 15000]);
            }
        },

        getcurGridInfo(obj) {
            this.curGridInfo = obj;
        },
        async getGridAreaList() {
            this.gridAreaList = await api.getGridAreaList().run();
        },
        renderMapLayers() {
            return [
                this.gridList.length > 0 && this.updateGridPoints && (
                    <GridPoints
                        gridList={this.gridList}
                        TaskInRunTimeList={this.TaskInRunTimeList}
                        hasAirLine={this.hasAirLine}
                        selectId={this.selectId}
                        selectFn={this.selectFn}
                    />
                ),
            ];
        },

        async getGridList(params) {
            this.updateGridPoints = false;
            if (params) {
                this.searchParams = Object.assign(this.searchParams, params);
            }

            let data = await api.getGridList(this.searchParams).run(false);
            console.log(data, '=============');

            let list = [];
            let filterSelectList = this.$refs.FilterSelect.itemList;
            this.hasAirLine = filterSelectList[0].checkValue; // 已规划航线标识
            data.forEach((item, idx) => {
                let obj = {
                    ...item,
                    points: this.CharacterToList(item.coordinates),
                };
                // 可飞
                if (filterSelectList[1].checkValue && item.executeStatus === 0) {
                    list.push(obj);
                }
                // 禁飞
                if (filterSelectList[2].checkValue && item.executeStatus === 1) {
                    list.push(obj);
                }
                // 停用
                if (filterSelectList[3].checkValue && item.executeStatus === 2) {
                    list.push(obj);
                }
                if (item.executeStatus == undefined) {
                    list.push(obj);
                }
            });

            this.gridList = list;
            this.$nextTick(() => {
                this.updateGridPoints = true;
                this.modules.MixMapModule.refreshSize();
            });
            return this.gridList;
        },

        CharacterToList(coordinates, type) {
            let arr = [];
            let coord = JSON.parse(coordinates);
            coord.regions.forEach((item, idx) => {
                let obj = [item.longitude, item.latitude];
                arr.push(obj);
            });
            return arr;
        },
    },
};
</script>

<style lang="scss" scoped>
.grid-manage {
    height: 100vh;
    display: flex;
}
</style>
